/**
 * Node names + attribute keys for the dynamic data-key / handlebars nodes.
 * These MUST stay in lockstep with the backend definitions
 * (`backend/src/app/utils/handlebars-nodes.ts`) — the Yjs schema is shared across
 * the editor and the backend markdown<->tiptap conversion.
 */
export const DATA_KEY_NODE_NAME = "dataKey";
export const CONTEXT_NODE_NAME = "contextKey";
export const DID_NODE_NAME = "did";
export const HANDLEBARS_NODE_NAME = "handlebars";
export const CONDITIONAL_NODE_NAME = "conditional";

export const DATA_KEY_ATTR = "dataKey";
export const CONTEXT_ATTR = "contextKey";
export const DID_ATTR = "did";
export const HANDLEBARS_TEMPLATE_ATTR = "template";
export const HANDLEBARS_INLINE_ATTR = "inline";
// The conditional node shares the handlebars node's storage shape (raw template
// string + block/inline flag), so it reuses the same attribute keys.
export const CONDITIONAL_TEMPLATE_ATTR = HANDLEBARS_TEMPLATE_ATTR;
export const CONDITIONAL_INLINE_ATTR = HANDLEBARS_INLINE_ATTR;

export const DID_PREFIX = "did-";
export const DID_SELECTION_KEY = DID_PREFIX;

export const isDidReference = (value: string): boolean =>
  value.startsWith(DID_PREFIX) && value.length > DID_PREFIX.length;
